exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-autocomplete li {\n  line-height: normal;\n  padding: 7px;\n}\n.my-autocomplete li .icon {\n    margin-right: 5px;\n    display: inline-block;\n    vertical-align: middle;\n}\n.my-autocomplete li .name {\n    display: inline-block;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    vertical-align: middle;\n}\n.my-autocomplete li .addr {\n    padding-top: 5px;\n    width: 100%;\n    font-size: 12px;\n    color: #b4b4b4;\n}\n.my-autocomplete li .highlighted .addr {\n    color: #ddd;\n}\n", ""]);

// exports
